import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export interface essentialData {
  statusMsg: string;
  msg: {
    settings: [
      {
        userEmail: string;
        clientId: number;
        salesOrg: number;
        colKey: string;
        colVal: string;
      }
    ];
    checkconfigs: [
      {
        code: string;
        text: string;
      }
    ];
    notes: [
      {
        clientId: string;
        createdBy: string;
        createdDt: Date;
        customerNum: string;
        isDeleted: Boolean;
        isImportant: Boolean;
        modifiedDt: Date;
        noteStatus: string;
        noteType: string;
        salesOrg: string;
        text: string;
        validUntilDt: Date;
      }
    ];
    routeconfig: [
      {
        param_name: string;
        param_value: number;
      }
    ];
    reviewconfig: [
      {
        param_name: string;
        param_value: number;
      }
    ];
    validTypes: [
      {
        code: string;
        text: string;
      }
    ];
  };
}

export async function GetEssentialData(salesOrg: string, planningDate: string, customerNum: string, clientId: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/planning/route_essentials/?customerNum=${customerNum}&planningDate=${planningDate}`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v: any) => v.data)
    .catch((err: any) => console.error(err));
}
